// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-update-task-tags.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm(
  $task_id: uuid!
  $task_tags: [tasks_tasks_tags_insert_input!]!
) {
  delete_tasks_tasks_tags(where: { task_id: { _eq: $task_id } }) {
    affected_rows
  }
  insert_tasks_tasks_tags(objects: $task_tags) {
    affected_rows
  }
}

`